<template>
  <v-container pa-0>
    <v-row>
      <div class="page__title">
        <h1>Moje punkty:</h1>
      </div>
    </v-row>

    <!-- TODO: for po partnerach -->
    <v-row class="organizations-list">
      <div v-for="n in 4" :key="n" class="organization">
        <header class="organization__header">
          <div class="organization__avatar">
            <!-- TODO: Wstawiać zdjęcie partnera -->
            <v-img contain alt="avatar" src="/img/avatar-no-image.jpg" />
          </div>

          <div class="organization__name">
            <h2>
              <!-- TODO: Wstawić nazwę partnera -->
              Jestem nazwą partnera {{ n }}
            </h2>
          </div>
        </header>

        <p class="d-flex">
          <v-icon class="mr-2 color-points">mdi-star-circle</v-icon>

          Zebrałeś już:
        </p>

        <ul class="organization__container-points">
          <li
            v-for="(containerPoints, index) in list"
            :key="'containerPoints_' + index"
            class="organization__container-points__item"
          >
            <div class="organization__container-points__item__title">
              <span class="color-points">
                {{ containerPoints.points }}

                pkt.
              </span>

              <span class="mx-2">
                -
              </span>

              {{ containerPoints.pointContainer.name }}:

              <v-btn elevation="0" class="ml-2" @click="getHistory(containerPoints.pointContainer.id)">
                <v-icon>mdi-history</v-icon>
              </v-btn>
            </div>

            <v-card v-if="containerPoints.pointContainer.id === containerHistoryId" xs12>
              <ul class="list-style--none pl-0">
                <li v-for="(pointHistory, index) in pointHistoryList" :key="'pointHistory_' + index" class="d-flex">
                  <div>
                    <v-icon :class="pointHistory.points > 0 ? 'green--text' : 'red--text'">
                      {{ pointHistory.points > 0 ? 'mdi-arrow-top-right' : 'mdi-arrow-bottom-right' }}
                    </v-icon>
                  </div>

                  <div>
                    <div>{{ pointHistory.points }} pkt - Użycie: {{ pointHistory.benefit.name }}</div>

                    <small>
                      {{ pointHistory.created | dateFilter }}
                    </small>
                  </div>
                </li>
              </ul>
            </v-card>
          </li>
        </ul>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { dateFilter } from '@witkac/kartamiejska-shared';
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { mapState } from 'vuex';

import { LocalStorage } from '@/enums/storage.enum';

/**
 * @vuese
 * Lista wszystkich kontenerów na punkty w których użytkownik miał jakiekolwiek punkty
 * @group ContainerPoints
 */
export default {
  filters: { dateFilter },
  data() {
    return {
      containerHistoryId: null
    };
  },
  computed: mapState({
    list: state => state.containerPoints.list,
    count: state => state.containerPoints.count,
    pointHistoryList: state => state.pointHistory.list
  }),
  methods: {
    // @vuese
    // Pobranie historii kontenera
    getHistory(pointContainerId) {
      if (this.containerHistoryId === pointContainerId) {
        this.containerHistoryId = null;
        return;
      }
      this.$store
        .dispatch('pointHistory/list', {
          pointContainerId,
          profileId: tryParseInt(localStorage.getItem(LocalStorage.PROFILE_ID))
        })
        .then(() => (this.containerHistoryId = pointContainerId));
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.organizations-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  .organization {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: solid 1px $color-border;

    &__header {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      margin-bottom: 24px;
    }

    &__avatar {
      width: 80px;
      height: 80px;
      border-radius: 4px;
      overflow: hidden;
      border: solid 1px $color-border;
      margin-right: 24px;
    }

    &__name {
      display: flex;
      flex-direction: column;
      padding-top: 16px;
      align-items: flex-start;
      justify-content: flex-start;
    }

    &__container-points {
      list-style: none;
      padding-left: 40px;
      border-left: solid 2px $color-points;
      margin-left: 10px;
      padding-left: 20px;

      &__item {
        &__title {
          font-weight: $weight-bold;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .v-btn {
            height: 32px;
            width: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 999px;
            padding: 0;
            min-width: unset;

            i {
              margin: 0;
              color: $color-active;
            }
          }
        }
      }
    }
  }
}

.color-points {
  color: $color-points !important;
}
</style>
